import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  myimage:string = './assets/images/logo-red.png';
  currentYear: number | undefined;
  constructor() { }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear()
  }

}